<template>
  <section class="hero">
    <div class="container hero__inner">
      <div class="hero__content">
        <div class="hero__badge">Расчёт премий, KPI и бонусов</div>
        <h1 class="hero__title">
          Премии — без Excel<br>
          <span class="hero__title-accent">и без ошибок</span>
        </h1>
        <p class="hero__text">
          CandB.pro считает премии по вашим формулам и KPI: импорт данных из Excel,
          расчёт по всей компании и ведомость в бухгалтерию. А&nbsp;Положение
          о&nbsp;премировании собирается автоматически из ваших формул — с расшифровкой
          «как посчитано» каждому сотруднику, онлайн, в любой момент периода.
        </p>
        <div class="hero__actions">
          <base-button to="/demo" size="lg">Получить демо-доступ на 14 дней</base-button>
          <base-button to="/features" variant="ghost" size="lg">Узнать больше</base-button>
        </div>
        <p class="hero__note">Настроим систему под ваши формулы за вас — бесплатно. Через 14 дней сверите наш расчёт со своим Excel.</p>
        <div class="hero__trust">
          <span>✓ Импорт из Excel</span>
          <span>✓ Премия по KPI</span>
          <span>✓ Положение о премировании</span>
          <span>✓ Ведомость для 1С</span>
        </div>
      </div>
      <div class="hero__visual">
        <div class="hero__browser">
          <div class="hero__browser-bar">
            <span class="hero__dot hero__dot--r"></span>
            <span class="hero__dot hero__dot--y"></span>
            <span class="hero__dot hero__dot--g"></span>
            <span class="hero__browser-url">app.candb.pro</span>
          </div>
          <img
            class="hero__shot"
            src="/img/app/calc-formula.png"
            alt="Интерфейс CandB.pro — конструктор формул с раскрытой формулой «Премия за продажи отдела = Выручка отдела продаж × Коэффициент» и расшифровкой"
            width="3456"
            height="1870"
          >
        </div>
        <div class="hero__card hero__card--float">
          <span class="hero__check">✓</span> Видно, как посчитана премия
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BaseButton from '../ui/BaseButton.vue'
export default {
  name: 'HeroSection',
  components: { BaseButton },
}
</script>

<style scoped>
.hero {
  background: linear-gradient(135deg, #1E3A8A 0%, #2563EB 60%, #0EA5E9 100%);
  padding: 160px 0 100px;
  color: white;
  overflow: hidden;
}
.hero__inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;
}
.hero__badge {
  display: inline-block;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 100px;
  padding: 6px 16px;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 24px;
}
.hero__title {
  font-size: 3rem;
  font-weight: 800;
  line-height: 1.15;
  margin-bottom: 20px;
}
.hero__title-accent { color: #93C5FD; }
.hero__text {
  font-size: 1.125rem;
  opacity: 0.88;
  line-height: 1.7;
  margin-bottom: 36px;
  max-width: 480px;
}
.hero__actions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.hero__note {
  font-size: 0.9375rem;
  opacity: 0.8;
  max-width: 480px;
  margin-bottom: 24px;
}
.hero__trust {
  display: flex;
  gap: 24px;
  font-size: 0.875rem;
  opacity: 0.75;
  flex-wrap: wrap;
}

.hero__browser {
  background: white;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(0,0,0,0.25);
}
.hero__browser-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #F1F5F9;
  border-bottom: 1px solid var(--border);
}
.hero__dot {
  width: 11px;
  height: 11px;
  border-radius: 50%;
  flex-shrink: 0;
}
.hero__dot--r { background: #FF5F57; }
.hero__dot--y { background: #FEBC2E; }
.hero__dot--g { background: #28C840; }
.hero__browser-url {
  margin-left: 12px;
  flex: 1;
  background: white;
  border: 1px solid var(--border);
  border-radius: 100px;
  padding: 4px 14px;
  font-size: 0.8125rem;
  color: var(--gray);
}
.hero__shot {
  display: block;
  width: 100%;
  height: auto;
}

.hero__card--float {
  position: absolute;
  bottom: -20px;
  left: -20px;
  background: var(--secondary);
  color: white;
  border-radius: 12px;
  padding: 14px 20px;
  font-size: 0.9375rem;
  font-weight: 600;
  box-shadow: 0 8px 24px rgba(16,185,129,0.35);
  display: flex;
  align-items: center;
  gap: 8px;
}
.hero__check { font-size: 1.1rem; }
.hero__visual { position: relative; }

@media (max-width: 900px) {
  .hero__inner { grid-template-columns: 1fr; }
  .hero__visual { display: none; }
  .hero__title { font-size: 2.25rem; }
}
</style>
